<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6 text-center">
        <a [routerLink]="['/dashboard']">
          <img src="assets/img/brand/logo-ladder.png" style="height: 150px" alt="Logo"/>
        </a>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">404</h1>
          <h4 class="pt-3">Oops! Você está perdido.</h4>
          <p class="text-muted">A página que vc procura não foi encontrada.</p>
        </div>
        <!-- <div class="input-prepend input-group">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="fa fa-search"></i></span>
          </div>
          <input id="prependedInput" class="form-control" size="16" type="text" placeholder="O que você procura?">
          <span class="input-group-append">
            <button class="btn btn-info" type="button">Localizar</button>
          </span>
        </div> -->
      </div>
    </div>
  </div>
</div>
